import React from 'react';
import { useSelector } from 'react-redux';

import { Dropdown } from "primereact/dropdown";
import { Oval } from 'react-loader-spinner';
import { checkPermissions } from '../utils';

import PermDetailsWrapper from '../common/PermDetailsWrapper';


function DropDownField(props) {
    const userDetails = useSelector(state => state.userDetails)

    const labelText = props.labelText ? props.labelText : ""

    const fieldName = props.name ? props.name : "name"
    const placeholder = props.placeholder ? props.placeholder : ""

    const options = props.options ? props.options : []
    const optionLabel = props.optionLabel ? props.optionLabel : ""
    const optionValue = props.optionValue ? props.optionValue : ""
    const value = props.value || props.value == 0 ? props.value : ""
    const isLoading = props.loading ? props.loading : false 
    const panelStyle = props.panelStyle ? props.panelStyle : {}
    const style = props.style ? props.style : {}
    let tooltip = props.tooltip ? props.tooltip : ''
    let tooltipOptions = props.tooltipOptions ? props.tooltipOptions : {}
    let className = props.className ? props.className : "w-100"

    const virtualScrollerOptions = props.virtualScrollerOptions ? props.virtualScrollerOptions : null

    const permissions = props.permissions ? props.permissions : []
    const permParameters = props.permParameters ? props.permParameters : {}

    let disabled = false 
    let isPermitted = false
    let permittedCompanyRoleIds = []
    let permittedExceptionUserRoleIds = []
    let permittedExceptionNegitiveUserRoleIds = []

    if(permissions.length){
        //console.log("permissions input", permissions)
        const permParams = {
            reqPermActionIds: permissions,
            permParameters: permParameters,
            activeCompanyRoleId: userDetails.activeCompanyRoleId,
            userRoleId: userDetails.activeRoleId,
            permExceptions: userDetails.permExceptions,
            permGeo: userDetails.permGeo,
            permActions: userDetails.permActions,
            permRoles: userDetails.permRoles,
            companyRoles: userDetails.companyDetails.companyRoles
        }
        const permissionDetails = checkPermissions(permParams)
        isPermitted = permissionDetails.isPermitted
        permittedCompanyRoleIds = permissionDetails.permittedCompanyRoleIds
        permittedExceptionUserRoleIds = permissionDetails.permittedExceptionUserRoleIds
        permittedExceptionNegitiveUserRoleIds = permissionDetails.permittedExceptionNegitiveUserRoleIds

        if(!isPermitted){
            disabled = true
        }
    }

    if(props.disabled){
        disabled = true
    }

    if(props.errorBorder){
        className = className + " red-border"
    }

    const handleOnchange = (e) => {
        if(props.onChange){
            props.onChange(e)
        }
    }

    const renderDropdown = () => (
        <>
            <div className='flex flex-column' style={{position:'relative'}}>
                { labelText ? <label htmlFor="" style={{fontSize: '12px', marginBottom: '3px'}}>{labelText}{ props.required && <span style={{color:"red"}}>*</span> }</label> : "" }
                <Dropdown 
                    className={`${className}`} 
                    name={props.name} 
                    options={options} 
                    optionLabel={optionLabel} 
                    optionValue={optionValue} 
                    value={value} 
                    placeholder={placeholder} 
                    style={style} 
                    panelStyle={panelStyle} 
                    virtualScrollerOptions={virtualScrollerOptions} 
                    onChange={(e) => handleOnchange(e)} 
                    disabled={disabled} 
                    tooltip={tooltip} 
                    tooltipOptions={tooltipOptions} 
                    itemTemplate={props.itemTemplate}
                    valueTemplate={props.valueTemplate}
                    optionDisabled={props.optionDisabled}
                />
                {isLoading && <Oval
                    height="20" 
                    width="20" 
                    radius="6"
                    color="#000" 
                    secondaryColor="#000"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{position: 'absolute', marginTop: '1.3rem'}}
                    wrapperClassName=""
                    visible={true}
                />}
                { props.errorMessage && <small className='p-error' style={{fontSize: 'x-small', marginTop: '0.25rem'}}>{props.errorMessage}</small> }
            </div>
        </>
    )

    return (
        <PermDetailsWrapper
            displayComponent={renderDropdown()}
            uniqueId={props.labelText}
            permissions={permissions}
            permittedCompanyRoleIds={permittedCompanyRoleIds}
            permittedExceptionUserRoleIds={permittedExceptionUserRoleIds}
            permittedExceptionNegitiveUserRoleIds={permittedExceptionNegitiveUserRoleIds}
            visible={!props.disabled && !isPermitted}
        />
    )
}

export default DropDownField;